import React, { useState, useEffect } from "react";
import Navbar from "../NavBar";
import Footer from "../Footer";
import Seo from "../Seo";
import { breadcrumbJsonLd } from "../../seoSchema";
import "../../styles/About.css";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { cmsHeroBackgroundStyle, CmsImage, resolveFirestoreImage, useCmsHeroImageReady } from "../../firestoreMedia";

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIRESTORE_API_KEY,
	authDomain: "wishuponaplayhouse.firebaseapp.com",
	projectId: "wishuponaplayhouse",
	storageBucket: "wishuponaplayhouse.firebasestorage.app",
	messagingSenderId: "513377368862",
	appId: "1:513377368862:web:eadda2a0b7bb141ffa670f",
	measurementId: "G-NZ116LS0Q1",
};

const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);

const DEFAULT_VALUES = [
	{ label: "Built On-Site",     body: "Every playhouse is constructed in your backyard by skilled craftsmen — no kits, no freight, no cranes." },
	{ label: "Quality Materials", body: "We use only durable, safe materials designed to last for many years of backyard adventures." },
	{ label: "Fully Custom",      body: "Choose colors, features, and add-ons — or dream up something entirely unique and we'll build it." },
	{ label: "Local & Personal",  body: "A locally-owned Colorado business. We work directly with each family from first call to final nail." },
];

function About() {
	const [title, setTitle]         = useState("");
	const [paragraph, setParagraph] = useState("");
	const [title2, setTitle2]       = useState("");
	const [paragraph2, setParagraph2] = useState("");
	const [aboutImage, setAboutImage] = useState({ url: "", base64: null });
	const [heroImage, setHeroImage] = useState(null);
	const [heroTitle, setHeroTitle] = useState("Our Story");
	const [heroEyebrow, setHeroEyebrow] = useState("Denver, Colorado");
	const [values, setValues] = useState(DEFAULT_VALUES);
	const [pageReady, setPageReady] = useState(false);
	useEffect(() => {
		(async () => {
			try {
				const snap = await getDoc(doc(firestore, "Pages", "AboutPage"));
				if (snap.exists()) {
					const d = snap.data();
				setTitle(d.title); setParagraph(d.paragraph);
				setTitle2(d.title2); setParagraph2(d.paragraph2);
				if (d.aboutImage) setAboutImage(d.aboutImage);
				if (d.heroImage) setHeroImage(d.heroImage);
				if (d.heroTitle) setHeroTitle(d.heroTitle);
				if (d.heroEyebrow) setHeroEyebrow(d.heroEyebrow);
				if (d.values && d.values.length > 0) setValues(d.values);
				}
			} catch (e) { console.error(e); }
			finally { setPageReady(true); }
		})();
	}, []);

	const abHeroUrl = pageReady ? resolveFirestoreImage(heroImage, "/images/sub-hero.png") : "";
	const abHeroReady = useCmsHeroImageReady(abHeroUrl, pageReady);

	return (
		<div className="ab-page">
			<Seo
				title="About Our Denver Playhouse Builders | Wish Upon A Playhouse"
				description="Locally owned Denver, Colorado playhouse builder. Meet the team handcrafting custom children's playhouses on-site in Colorado backyards — no kits, no freight, built to last."
				path="/about"
				jsonLd={breadcrumbJsonLd([
					{ name: "Home", path: "/" },
					{ name: "About", path: "/about" },
				])}
				jsonLdId="about-breadcrumb"
			/>
			<Navbar />

		<>
			{/* ── HERO ── */}
					<div className="sub-hero">
						<div
							className={`sub-hero-bg${pageReady ? "" : " cms-hero-pending-fill"}`}
							style={{
								...cmsHeroBackgroundStyle(!pageReady, heroImage, "/images/sub-hero.png"),
								opacity: pageReady ? (abHeroReady ? 1 : 0) : 1,
								transition: "opacity 0.55s cubic-bezier(0.22, 1, 0.36, 1)",
							}}
						/>
						<div className="sub-hero-overlay" />
						<div className="sub-hero-content">
						<p className="sub-hero-eyebrow">{heroEyebrow}</p>
						<h1 className="sub-hero-title">{heroTitle}</h1>
						</div>
					</div>

					{/* ── STORY SECTION ── */}
					<div className="ab-story">
						<div className="ab-story-img-wrap">
							<CmsImage
								pending={!pageReady}
								image={aboutImage}
								fallback="/images/sub-hero.png"
								alt="Wish Upon A Playhouse — Denver, Colorado custom children's playhouse builder"
								className="ab-story-img"
								onError={(e) => { e.target.onerror = null; e.target.src = "/images/sub-hero.png"; }}
							/>
						</div>
						<div className="ab-story-text">
							<h2 className="ab-story-title">{title}</h2>
							<div className="ab-story-rule" />
							<p className="ab-story-body">{paragraph}</p>
						</div>
					</div>

				{/* ── VALUES STRIP ── */}
				<div className="ab-values">
					{values.map(v => (
							<div key={v.label} className="ab-value-card">
								<h3 className="ab-value-label">{v.label}</h3>
								<p className="ab-value-body">{v.body}</p>
							</div>
						))}
					</div>

					{/* ── SECOND SECTION ── */}
					<div className="ab-second">
						<div className="ab-second-inner">
							<h2 className="ab-second-title">{title2}</h2>
							<div className="ab-story-rule ab-story-rule--center" />
							<p className="ab-second-body">{paragraph2}</p>
							<a href="/contact" className="ab-cta-btn">
								<span>Get in Touch</span>
								<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
									<path d="M3 8H13M13 8L9 4M13 8L9 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
							</a>
						</div>
					</div>
		</>
		<Footer />
		</div>
	);
}

export default About;
